import useCustomHook from '@/hooks/useCustomHook';
import { useEffect } from 'react';
import { defaultVideoHeight } from '../VideoPlayer/useVideoPlayer.hook';

export default function usePlayerControls({
  videoUrls,
  onVideoUrlChange,
  selectRef,
}) {
  const { state, actions } = useCustomHook({
    defaultState: {
      videoUrlIndex: 0,
    },
    actions: {
      setVideoUrlIndex: (videoUrlIndex) => {
        actions.setState({ videoUrlIndex });
        onVideoUrlChange(videoUrls[videoUrlIndex]);
        selectRef.current?.blur();
      },
    },
  });

  useEffect(() => {
    const index = videoUrls?.findIndex(
      (url) => url.height == defaultVideoHeight
    );
    actions.setState({
      videoUrlIndex: index != -1 ? index : 0,
    });
  }, [videoUrls]);

  return { state, actions };
}
